module.exports = __webpack_public_path__ + "img/index_img1.2b84140e.png";